export class IntegradorApontamento {
  id: number;
  idIntegrador: number;
  texto: string;
  dataHora: Date;  
  idUsuario: number;
  nomeUsuario: string;
}
